import { Component, inject, OnInit } from '@angular/core';

import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { DocumentService } from '../../shared/services/document.service';

@Component({
  selector: 'lfw-manual-page',
  template: `
    <ngx-extended-pdf-viewer
      [src]="blob"
      [showOpenFileButton]="false"
      [showDrawEditor]="false"
      [showTextEditor]="false"
      [showStampEditor]="false"
      [showHighlightEditor]="false"
      [showFindButton]="true"
      [textLayer]="true"></ngx-extended-pdf-viewer>
  `,
  styles: ``,
  imports: [NgxExtendedPdfViewerModule]
})
export class ManualPageComponent implements OnInit {
  private documentService = inject(DocumentService);

  blob: Blob = new Blob();

  ngOnInit(): void {
    this.documentService.getManual().subscribe((res) => {
      this.blob = res;
    });
  }
}
